import Style from "../style/StartQuiz.module.scss";
import BackArrow from '../../../../assets/svg/BackArrow';
import QuizWallicon from '../../../../assets/svg/QuizWallicon';
import Coin from "../../../../assets/svg/Coin";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from '../../../../assets/theme6/start_btn.svg'
import Boy from '../../../../assets/theme6/boy.svg'
import Girl from '../../../../assets/theme6/girl.svg'
import SmartDisplayOutlinedIcon from '@mui/icons-material/SmartDisplayOutlined';
import { getChallangeDetailAction } from "../../../../redux/screen/challangedetails";
import StartChallengeNew from "./StartChallengeNew";
import Attempt from "../../../../assets/svg/Attempt";
import Round from "../../../../assets/svg/Round";
const StartQuiz = () => {
	const { id } = useParams();

	const navigate = useNavigate()
	const dispatch = useDispatch()
	const [open, setOpen] = useState(false)
	const challangeDetail = useSelector(state => state.getChallangeDetail)
	const { data: missionDetailData, loading: missionDetailLoading, status, message } = challangeDetail
	window.scrollTo({
		top: 0,
		behavior: 'smooth' // Optional: smooth scrolling animation
	});

	if (status === 403) {
		navigate('/home-challenge')
	}
	const handleBackClick = () => {
		// Check if there's history to go back to
		if (window.history.length > 2) {
			navigate(-1);
		} else {
			// No history, go to home
			navigate('/home-challenge');
		}
	};

	if (status === 401) {
		alert(message)
	}
	useEffect(() => {
		dispatch(getChallangeDetailAction(id))
	}, [dispatch])
	const scrollToTop = () => {
		window.scrollTo(0, 0);
	};

	useEffect(() => {
		scrollToTop();
	}, [dispatch])

	return (
		<>
			{open ? <StartChallengeNew challengeID={id} /> :
				<div className={Style.box_container}>
					<div className={Style.challenge_box_container_top}>
						<div onClick={() => handleBackClick()}>
							<BackArrow />
						</div>
						<QuizWallicon width={143} height={31} />
					</div>

					<div className={Style.challenge_box_container}>
						<div className={Style.quiz_container}>
							<div className={Style.quiz_box1}>
								<div className={Style.quizImage}>
									<img src={missionDetailData?.image} width="100%" height="100%" alt={missionDetailData?.challenge_name} />
								</div>
							</div>

							<div className={Style.quiz_box2}>
								<p className={Style.quiz_name}>{missionDetailData?.challenge_name}</p>
								<div className={Style.quiz_box5}>
									<div className={Style.quiz_box50}>

										<div className={Style.quiz_box51}>
											<img src={Boy} />
										</div>
										<div className={Style.quiz_box52}>
											<img src={Girl} />
										</div>
										<div className={Style.quiz_box53}>
											<img src={Boy} />
										</div>
									</div>
									<p className={Style.quiz_box5_p}>{`+${missionDetailData?.totalAttempts || 0} Participants`}</p></div>
								<div className={Style.quiz_box6}><Coin width={20} height={20} /><p className={Style.quiz_box6_p}>{missionDetailData?.reward}</p></div>
							</div>

						</div>


						<div className={Style.oneQuizInfo}>
							<div className={Style.pointsBox}>
								<div className={Style.heroPoint}>
									<SmartDisplayOutlinedIcon className={Style.white} />

									<h5>{missionDetailData.totalQuestion} Q</h5>
								</div>
								<div className={Style.heroPoint}>
									<Round width={18} height={18} className={Style.white} />

									<h5>{missionDetailData.rounds} Rounds</h5>
								</div>
								<div className={Style.heroPoint}>
									<Attempt width={16} height={16} className={Style.white} />

									<h5>{missionDetailData.myAttempt}/{missionDetailData?.maxAttempt}</h5>
								</div>
							</div>

							<div className={Style.infoPoint}>

								<h3 className={Style.workText}>How it Works?</h3>
								{missionDetailData?.how_to_use_points?.map((point, index) => (
									<div
										key={index}
										className={Style.howToUseBox}
									>
										<span className={Style.howToUseBoxBox}>{index + 1}</span>
									<p className={Style.howToUseBoxText}>{point}</p>

										{/* <div dangerouslySetInnerHTML={{ __html: point }} className={Style.howToUseBoxTextBox} /> */}
									</div>
								))}
							</div>
							<div className={Style.reward} onClick={() => setOpen(true)}><img src={Button} alt="btn_image" /></div>

						</div>





					</div>

				</div>
			}
		</>
	)
}

export default StartQuiz;
